<template>
  <div class="home">
    <!-- <top-bar></top-bar> -->
    <top-slider></top-slider>
    <top-menu></top-menu>

    <!-- main -->
    <div class="main_box">
      <div class="wrap">

      <!-- 个人服务&法人服务 -->
      
      <div class="service_slider">
        <div class="left">
          <ul>
            <li class="active" @click="switchCarousel(0)"><span>个人服务</span></li>
            <li @click="switchCarousel(1)"><span>企业服务</span></li>
          </ul>
        </div>
        <div class="right">
          <el-carousel ref="ser_slider" arrow="never" indicator-position="none" :autoplay="false" :height="carouselHeight">
            <el-carousel-item>
              <ul>
                <li v-for="item in dataPersonal" :key="item.id"><a :href="item.url"><span><img :src="item.icon" alt=""></span>{{item.title}}</a></li>
              </ul>
            </el-carousel-item>
            <el-carousel-item>
              <ul>
                <li v-for="item in dataEnterprise" :key="item.id"><a :href="item.url"><span><img :src="item.icon" alt=""></span>{{item.title}}</a></li>
              </ul>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
     

      <!-- 最新动态 -->
      <div class="box_zxdt">
        <div class="title">
          <h2>最新动态</h2>
          <router-link :to="{name:'NewsInformation'}" class="more">更多+</router-link>
        </div>
        <div class="content_com">
          
          <div class="left">
            <div v-for="(item,index) in dataZxdtLeft" :key="index">
              <a @click.prevent="confirmClick(item.linkUrl)" v-if="item.linkUrl" :href="item.linkUrl" target="_blank">
                <h3>{{item.title}}</h3>
                <div class="desc">{{item.desc}}</div>
              </a>
              <router-link v-else :to="'/detail/'+item.id" target="_blank">
                <h3>{{item.title}}</h3>
                <div class="desc">{{item.desc}}</div>
              </router-link>
            </div>
          </div>
          <div class="right">
            <news-list :dataList="dataZxdtRight" :aWidth="aWidth" :dateIsShow="dateIsShow"></news-list>
          </div>
        </div>
      </div>

      <div class="box">
        <!-- 公告通知 -->
        <div class="box_ggtz">
          <div class="title">
            <h2>公告通知</h2>
            <router-link :to="{name:'Notice'}" class="more">更多+</router-link>
          </div>
          <div class="content_com">
            <news-list :dataList="dataTzgg" :aWidth="aWidth" :dateIsShow="dateIsShow"></news-list>
          </div>
        </div>

        <!-- 办事指南 -->
        <div class="box_bszn">
          <div class="title">
            <h2>办事指南</h2>
            <router-link :to="{name:'SelfEmployment'}" class="more">更多+</router-link>
          </div>
          <div class="content_com">
            <news-list :dataList="dataBszn" :aWidth="bsznWidth" :dateIsShow="!dateIsShow"></news-list>
          </div>
        </div>
      </div>

      <!-- <div class="box"> -->
        <!-- 招聘信息 -->
        <!-- <div class="box_zpxx">
          <div class="title">
            <h2>招聘信息</h2>
            <router-link :to="{name:'RecruitmentInfo'}" class="more">更多+</router-link>
          </div>
          <div class="content_com">
                <ul class="zpxx_list">
                    <li v-for="(item,index) in dataZpxx" :key="index">
                        <h4><router-link :to="'/recruitDetail/'+item.id">{{item.jobVacancy}}</router-link><span class="date">{{item.pushTime}}</span></h4>
                        <div class="desc">
                          <span class="salary">{{item.salaryRange}}</span><span>{{item.workAddress}}</span><span>{{item.education}}</span><span>{{item.workYears}}</span><span>{{item.jobNum}}人</span>
                        </div>
                    </li>
                </ul>
          </div>
        </div> -->

        <!-- 问卷调查 -->
        <!-- <div class="box_wjdc">
          <div class="title">
            <h2>问卷调查</h2>
            <router-link :to="{name:'Investigation'}" class="more">更多+</router-link>
          </div>
          <div class="content_com">
            <investigation-list :dataList="dataWjdc" :aWidth="aWidth" :dateIsShow="dateIsShow"></investigation-list>
          </div>
        </div>
      </div> -->

      <!-- 人物风采 -->
      <div class="box_rwfc">
          <div class="title">
            <h2>人物风采</h2>
            <router-link :to="{name:'Character'}" class="more">更多+</router-link>
          </div>
          <div class="content_rwfc">
            <ul class="mixList">
              <li v-for="item in dataRwfc" :key="item.id">
                <div class="pic">
                  <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank"><img :src="item.imgSrc[0].url" :alt="item.title"></a>
                  <router-link v-else :to="'/detail/'+item.id" target="_blank"><img :src="item.imgSrc[0].url" :alt="item.title"></router-link>
                </div>
                <div class="txtCon">
                  <h3>
                    <a v-if="item.linkUrl" :href="item.linkUrl" target="_blank">{{item.title}}</a>
                    <router-link v-else :to="'/detail/'+item.id" target="_blank">{{item.title}}</router-link>
                  </h3>
                  <div class="desc">
                    <p>{{item.desc}}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
      </div>
      
      <!-- 友情链接 -->
      <div class="box_yqlj">
        <h2>友情链接:</h2>
        <ul>
          <li v-for="item in dataFriLinks" :key="item.title"><a :href="item.url" target="_blank">{{item.title}}</a></li>
        </ul>
      </div>

      </div>
    </div>

    <!-- 右侧固定浮窗 -->
    <div class="float_win">
      <div class="avator"></div>
      <div class="close" @click="closeFloatWin"></div>
      <!-- <ul>
        <li v-for="item in dataBayWin" :key="item.id"><a :href="item.url">{{item.title}}</a></li>
      </ul> -->
      <div class="qrCode">
        <h2>北京市海淀区退役<br>军人事务局公众号</h2>
        <div class="pic"></div>
      </div>
    </div>
    <Footer></Footer>
    <div class="dialog_other_link" v-show="confirm">
      <div @click="close" class="close">X</div>
      <div class="content">
        <p>您访问的链接即将离开“海淀区人民政府”门户网站</p>
        <p>是否继续？</p>
      </div>
      <div class="btn_box">
        <span @click="goLink" class="btn_jxfw">继续访问</span>
        <span @click="close" class="btn_fq">放弃</span>
      </div>
    </div>
    <div class="dialog_mask" v-show="confirm"></div>
  </div>
</template>

<script>
import $ from 'jquery'
import NewsList from '@/components/NewsList.vue'
import { getLists,getWjdcLists,getBayWin,getServicesMenu,getFriLinks,getRecruitmentPage } from '@/service/api.js'
import * as util from '@/utils/util.js'
import TopMenu from '@/components/TopMenu.vue'
// import InvestigationList from '@/components/InvestigationList.vue'
// import TopBar from '@/components/TopBar.vue'
import Footer from '@/components/Footer.vue'
import TopSlider from '@/components/TopSlider.vue'

export default {
  // components: { NewsList,TopMenu,TopBar,Footer,TopSlider },
  components: { NewsList,TopMenu,Footer,TopSlider },
  data() {
    return {
      carouselHeight:'',
      aWidth: 'width:100%',
      dateIsShow:false,
      bsznWidth: 'width:80%',
      dataZxdtLeft:[],
      dataZxdtRight:[],
      dataTzgg:[],
      dataBszn:[],
      dataZpxx:[],
      dataWjdc:[],
      dataRwfc:[],
      dataBayWin:[],
      dataPersonal:[],
      dataEnterprise:[],
      dataFriLinks:[],
      pageParams:{
          pageNo:1,
          pageSize:6
      },
      salaryRangeOptions:{
          0:"面议",
          1:"3000以下",
          2:"3000-5000",
          3:"5000-9000",
          4:"9000以上",
      },
      workYearsOptions:{
          0:"不限",
          1:"1-3年",
          2:"3-5年",
          3:"5-10年",
          4:"10年以上",
      },
      confirm: false,
      linkUrl: '',
    }
  },
  methods: {
    switchCarousel(index) {
      $('.service_slider .left li').removeClass('active');
      $('.service_slider .left li').eq(index).addClass('active')
      this.$refs.ser_slider.setActiveItem(index);
      let tempHeight = Math.ceil($('.service_slider .el-carousel__item').eq(index).find('li').length/3)
      console.log(tempHeight);
      if (tempHeight<2) {
        tempHeight = 2
      }
      this.carouselHeight = tempHeight*70+20+'px'
    },
    closeFloatWin (){
      $('.float_win').hide()
    },
    // 跳转外链前打开确认弹窗
    confirmClick(url) {
      this.confirm = true
      this.linkUrl = url
    },
    // 关闭弹窗
    close() {
      this.confirm = false
      this.linkUrl = ''
    },
    // 继续访问
    goLink() {
      window.open(this.linkUrl)
      this.close()
    }
  },
  mounted () {
    
    // 获取友情链接
    getFriLinks().then((data) => {
      if (data.code !==0) {
        this.$message.error(data.msg)
      }else{
        if(data.data.length){
          for (let i = 0; i < data.data.length; i++) {
            let temp = {};
            temp.title = data.data[i].name;
            temp.url = data.data[i].url;
            this.dataFriLinks.push(temp)
          }
        }
      }
    })

    //获取个人服务和企业服务菜单
    getServicesMenu().then((data) => {
      if (data.code !==0) {
        this.$message.error(data.msg)
      }else{
        // 企业服务菜单
        if(data.data.enterprise.length){
          for (let i = 0; i < data.data.enterprise.length; i++) {
            let temp = {};
            temp.title = data.data.enterprise[i].name;
            temp.id = data.data.enterprise[i].id;
            temp.icon = data.data.enterprise[i].icon;
            if(data.data.enterprise[i].openUrl){
              temp.url = data.data.enterprise[i].openUrl
            }else {
              temp.url = '/'
            }
            this.dataEnterprise.push(temp)
          }
        }
        // 个人服务菜单
        if(data.data.personal.length){
          if (Math.ceil(data.data.personal.length/3)<=2) {
            this.carouselHeight = '160px'
          }else{
            this.carouselHeight = Math.ceil(data.data.personal.length/3)*70+20+'px'
          }
          for (let i = 0; i < data.data.personal.length; i++) {
            let temp = {};
            temp.title = data.data.personal[i].name;
            temp.id = data.data.personal[i].id;
            temp.icon = data.data.personal[i].icon;
            if(data.data.personal[i].openUrl){
              temp.url = data.data.personal[i].openUrl
            }else {
              temp.url = '/'
            }
            this.dataPersonal.push(temp)
          }
          console.log('this.dataPersonal',this.dataPersonal);
        }
      }      
    });
    //右侧浮窗
    getBayWin().then((data) => {
      if (data.code !==0) {
        this.$message.error(data.msg)
      }else{
        if (data.data.length) {
          for (let i = 0; i < data.data.length; i++) {
            let temp = {};
            temp.title = data.data[i].title;
            temp.id = data.data[i].bayWindowId;
            temp.url = data.data[i].linkUrl;
            this.dataBayWin.push(temp)
          }
        }
      }      
    });
    // 最新动态
    getLists({type:0}).then((data) => {
      if (data.code !==0) {
        this.$message.error(data.msg)
      }else{
        for (let i = 0; i < 2; i++) {
          if (data.data[i]) {
            let temp = {};
            temp.title = data.data[i].title;
            temp.desc = data.data[i].content.replace(/<\/?[^>]*>/g,'').replace(/[\r\n|&nbsp;]/g,'').slice(0,70)+'...';
            temp.id = data.data[i].id;
            temp.linkUrl = data.data[i].linkUrl
            this.dataZxdtLeft.push(temp)
          } else {
            break
          }
        }
        for (let i = 2; i < 8; i++) {
          if (data.data[i]) {
            let temp = {};
            temp.id = data.data[i].id;
            temp.title = data.data[i].title;
            temp.date = util.dateFormat(data.data[i].pushTime,'Y-M-D')
            temp.linkUrl = data.data[i].linkUrl
            this.dataZxdtRight.push(temp)
          } else {
            break
          }
        }
      }      
    });
    // 通知公告
    getLists({type:1}).then((data) => {
      if (data.code !==0) {
        this.$message.error(data.msg)
      }else{
        if (data.data.length) {
          for (let i = 0; i < 6; i++) {
            if (data.data[i]) {
              let temp = {};
              temp.title = data.data[i].title;
              temp.id = data.data[i].id;
              temp.date = util.dateFormat(data.data[i].pushTime,'Y-M-D')
              temp.linkUrl = data.data[i].linkUrl
              this.dataTzgg.push(temp)
            } else {
              break
            }
          }
        }
      }      
    });
    // 办事指南
    getLists({type:3}).then((data) => {
      if (data.code !==0) {
        this.$message.error(data.msg)
      }else{
        for (let i = 0; i < 6; i++) {
          if (data.data[i]) {
            let temp = {};
            temp.title = data.data[i].title;
            temp.id = data.data[i].id;
            temp.date = util.dateFormat(data.data[i].pushTime,'Y-M-D')
            temp.linkUrl = data.data[i].linkUrl
            this.dataBszn.push(temp)
          } else {
            break
          }
        }
      }      
    });
    // 招聘信息
    getRecruitmentPage(this.pageParams).then(data=>{
        console.log('招聘信息:',data);
        if (data.code !==0) {
            this.$message.error(data.msg)
        }else{
            this.dataZpxx = data.data.list
            this.dataZpxx.forEach(el => {
                el.pushTime = util.dateFormat(el.pushTime,'Y-M-D')
                el.salaryRange = this.salaryRangeOptions[el.salaryRange]
                el.workYears = this.workYearsOptions[el.workYears]
            });
        }
    })
    // 问卷调查
    getWjdcLists({}).then(data=>{
      console.log('问卷调查',data);
      if (data.code!==0) {
        this.$message.error(data.msg)
      }else{
        if (data.data.list.length!==0) {
          let listLen = 0
          data.data.list.length<6?listLen=data.data.list.length:listLen=6
          for (let i = 0; i < listLen; i++) {
            let temp = {};
            temp.title = data.data.list[i].name;
            temp.id = data.data.list[i].id;
            temp.key = data.data.list[i].key;
            this.dataWjdc.push(temp)
          }
        }
      }
    });
    // 人物风采
    getLists({type:7}).then((data) => {
      console.log('人物风采',data);
      if (data.code !==0) {
        this.$message.error(data.msg)
      }else{

        for (let i = 0; i < 4; i++) {
          if (data.data[i]) {
            let temp = {};
            temp.title = data.data[i].title;
            temp.id = data.data[i].id;
            temp.desc = data.data[i].content.replace(/<\/?[^>]*>/g,'').replace(/[\r\n|&nbsp;]/g,'').slice(0,70)
            temp.desc = temp.desc ? temp.desc+'...' : temp.desc
            temp.imgSrc = JSON.parse(data.data[i].files)
            temp.linkUrl = data.data[i].linkUrl
            this.dataRwfc.push(temp)
          } else {
            break
          }
        }
      }
    });
  },
};
</script>
<style lang="less" scoped>
.main_box {
  width: 100%;
  background: url(../../assets/images/index/bg_main.jpg) no-repeat center bottom;
  max-width: 1920px;
  margin: 35px auto 0;
  overflow: hidden;
}
.service_slider {
  overflow: hidden;
  .left {
    width: 200px;
    float: left;
    ul {
      li {
        width: 200px;
        height: 70px;
        border: solid 1px #e6e6e6;
        line-height: 70px;
        text-align: center;
        font-size: 20px;
        color: #999;
        font-weight: 600;
        cursor: pointer;
        &:hover {
          background-color: #18388b;
          color: #FFF;
        }
        &.active {
          background-color: #18388b;
          color: #FFF;
        }
        &:nth-of-type(1) {
          span {
            &::before {
              content: '';
              background: url(../../assets/images/index/icon_grfw.png) no-repeat;
              width: 26px;
              height: 24px;
              display: inline-block;
              vertical-align: middle;
              margin-right: 10px;
            }
          }
          &:hover {
            span {
               &::before {
                 background: url(../../assets/images/index/icon_grfw_active.png) no-repeat;
               }
            }
          }
          &.active {
            span {
               &::before {
                 background: url(../../assets/images/index/icon_grfw_active.png) no-repeat;
               }
            }
          }
        }
        &:nth-of-type(2) {
          margin-top: 20px;
          span {
            &::before {
              content: '';
              background: url(../../assets/images/index/icon_qyfw.png) no-repeat;
              width: 28px;
              height: 24px;
              display: inline-block;
              vertical-align: middle;
              margin-right: 10px;
            }
          }
          &:hover {
            span {
               &::before {
                 background: url(../../assets/images/index/icon_qyfw_active.png) no-repeat;
               }
            }
          }
          &.active {
            span {
               &::before {
                 background: url(../../assets/images/index/icon_qyfw_active.png) no-repeat;
               }
            }
          }
        }
      }
    }
  }
  .right {
    background-color: #eff2f8;
    width: 980px;
    float: right;
    ul {
      li {
        float: left;
        margin: 20px 0 0 27.5px;
        a {
          display:block;
          width: 290px;
          height: 50px;
          background-color: #FFF;
          line-height: 50px;
          padding-left: 20px;
          span {
            display: inline-block;
            width: 30px;
            height: 30px;
            vertical-align: middle;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
.txtEllipsis {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.title {
  height: 28px;
  background-color: #f5f8fc;
  position: relative;
  h2 {
    width: 168px;
    height: 28px;
    text-indent: -1978px;
    overflow: hidden;
  }
  .more {
    position: absolute;
    right: 0;
    top: 0;
    width: 63px;
    height: 28px;
    background-color: #18388b;
    color: #FFF;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
  }
}
.content_com {
  margin-top: 25px;
  overflow: hidden;
  height: 210px;
}
.box {
  overflow: hidden;
  margin-top: 20px;
}
.box_zxdt {
  margin-top: 35px;
  .title {
    h2 {
      background: url(../../assets/images/index/title_zxdt.png) no-repeat #FFF;
    }
  }
  .content_com {
    .left {
      width: 580px;
      float: left;
      div:last-child {
        margin-top: 10px;
      }
      a {
        display: block;
        padding-bottom: 10px;
        border-bottom: dashed 1px #d1d1d1;
        h3 {
          font-size: 18px;
          font-weight: 600;
          text-align: center;
          line-height: 1;
          .txtEllipsis;
        }
        .desc {
          color: #666;
          line-height: 1.6;
          text-indent: 2em;
          margin-top: 10px;
        }
        &:nth-of-type(2) {
          margin-top: 15px;
          border: none;
        }
      }
    }
    .right {
      width: 580px;
      float: right;
      .news_list {
        li {
          a {
            width: 80% !important;
          }
        }
      }
    }
  }
}
.box_ggtz {
  width: 580px;
  float: left;
  .title {
    h2 {
      background: url(../../assets/images/index/title_ggtz.png) no-repeat #FFF;
    }
  }
}
.box_bszn {
  width: 580px;
  float: right;
  .title {
    h2 {
      background: url(../../assets/images/index/title_bszn.png) no-repeat #FFF;
    }
  }
}
.box_zpxx {
  width: 580px;
  float: left;
  .title {
    h2 {
      background: url(../../assets/images/index/title_zpxx.png) no-repeat #FFF;
    }
  }
}
.zpxx_list {
  li{
    line-height: 1;
    padding-bottom: 8px;
    border-bottom: dashed 1px #DDD;
    margin-bottom: 20px;
    &:last-child {
      border: none;
    }
  }
  h4 {
    margin-bottom: 10px;
  }
  span {
    display: inline-block;
    padding: 3px 5px;
    font-size: 14px;
    color: #999;
    &::after {
      content: '';
      display: inline-block;
      width: 1px;
      height: 12px;
      background: #999;
      vertical-align: middle;
      margin-left: 10px;
    }
    &.salary {
      color: #fc703e;
      margin-left: 0;
      font-size: 16px;
      &::after {
        display: none;
      }
    }
    &:last-child {
      &::after {
        display: none;
      }
    }
  }
  .date {
    float: right;
    background: none;
  }
}
.box_wjdc {
  width: 580px;
  float: right;
  .title {
    h2 {
      background: url(../../assets/images/index/title_wjdc.png) no-repeat #FFF;
    }
  }
}
.box_rwfc {
  margin-top: 20px;
  .title {
    h2 {
      background: url(../../assets/images/index/title_rwfc.png) no-repeat #FFF;
    }
  }
  .content_rwfc {
    margin-top: 25px;
    overflow: hidden;
    .mixList {
      overflow: hidden;
      li {
        float: left;
        overflow: hidden;
        width: 580px;
        height: 147px;
        margin-bottom: 20px;
        &:nth-of-type(2n) {
          margin-left: 40px;
        }
        .pic {
          width: 164px;
          height: 111px;
          float: left;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txtCon {
          width: 400px;
          height: 111px;
          overflow: hidden;
          float: right;
          h3 {
            a {
              display: block;
              font-size: 18px;
              font-weight: 600;
              line-height: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .desc {
            color: #666;
            line-height: 1.4;
            margin-top: 15px;
            text-align: justify;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
          }
        }
      }
    }
  }
}
.box_yqlj {
  height: 70px;
  background-color: #f5f8fc;
  overflow: hidden;
  margin: 20px 0 50px;
  line-height: 70px;
  h2 {
    width: 120px;
    margin-left: 35px;
    float: left;
    &::before {
      content: '';
      background: url(../../assets/images/index/icon_link.png) no-repeat;
      display: inline-block;
      vertical-align: middle;
      width: 18px;
      height: 23px;
      margin: -3px 10px 0 0;
    }
  }
  ul {
    overflow: hidden;
    float: left;
    li {
      float: left;
      margin-right: 10px;
    }
  }
}
.float_win {
  width: 210px;
  background: #FFF;
  border: solid 1px #0779bf;
  position: fixed;
  bottom: 50px;
  right: 10px;
  padding-bottom: 20px;
  z-index: 999;
  .qrCode {
    padding-top: 60px;
    h2 {
      font-size: 18px;
      padding: 0 15px;
      text-align: center;
    }
    .pic {
      background: url(../../assets/images/ewm.png) no-repeat;
      background-size: 100% 100%;
      margin: 10px auto 0;
      width: 188px;
      height: 188px;
    }
  }
  .avator {
    background: url(../../assets/images/icon_fixed_head.png) no-repeat;
    width: 115px;
    height: 115px;
    position: absolute;
    left: 50%;
    top: -58px;
    z-index: 2;
    margin-left: -58px;
  }
  .close {
    background: url(../../assets/images/icon_fixed_close.png) no-repeat;
    width: 20px;
    height: 20px;
    position: absolute;
    top: -10px;
    right: -10px;
    z-index: 2;
    cursor: pointer;
  }
  ul {
    width: 100px;
    overflow: hidden;
    margin: 0 auto;
    padding-top: 60px;
    li {
      margin-top: 15px;
      a {
        line-height: 18px;
        &::before {
          content: '';
          background: url(../../assets/images/icon_fixed_line.png) no-repeat;
          width: 23px;
          height: 18px;
          display: inline-block;
          vertical-align: middle;
          margin: -3px 10px 0 0;
        }
      }
    }
  }
}

.dialog_mask {
    // width: 100vw;
    // height: 100vh;
    background: #000;
    opacity: .5;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99;
  }
  .dialog_other_link {
    height: 270px;
    background: #FFF;
    padding: 0 60px;
    overflow: hidden;
    position: fixed;
    left: 50%;
    top: 100px;
    margin: 0 0 0 -300px;
    z-index: 999;

    .close {
      width: 20px;
      height: 20px;
      background-color: #ababab;
      color: #FFF;
      line-height: 20px;
      text-align: center;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 9;
      cursor: pointer;
    }

    .content {
      margin: 50px auto 0;
      font-size: 20px;
      text-align: center;
      padding-bottom: 30px;
      border-bottom: solid 1px #EDEDED;
      width: auto;
      height: auto;
      position: relative;
    }

    .btn_box {
      text-align: center;
      margin-top: 30px;
    }

    .btn_jxfw {
      display: inline-block;
      vertical-align: top;
      width: 120px;
      height: 40px;
      border: solid 1px #EEE;
      border-radius: 10px;
      font-size: 20px;
      color: #aa0000;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }
    .btn_fq {
      font-size: 20px;
      color: #aa0000;
      margin-left: 20px;
      line-height: 40px;
      cursor: pointer;
    }
  }
</style>